"use client";

import React, {useState} from "react";
import {cn} from "@root/server/client/esweb/lib/utils";

interface GalleryImageWithLoaderProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    wrapperClassName?: string;
    placeholderClassName?: string;
}

export function GalleryImageWithLoader({
    wrapperClassName,
    placeholderClassName,
    className,
    onLoad,
    onError,
    ...imgProps
}: GalleryImageWithLoaderProps) {
    const [loaded, setLoaded] = useState(false);

    const handleLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
        setLoaded(true);
        onLoad?.(event as React.SyntheticEvent<HTMLImageElement>);
    };

    const handleError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        setLoaded(true);
        onError?.(event as React.SyntheticEvent<HTMLImageElement>);
    };

    return (
        <div className={cn("relative", wrapperClassName)}>
            {!loaded && (
                <div className={cn("absolute inset-0 animate-pulse bg-muted", placeholderClassName)} aria-hidden="true" />
            )}
            <img
                {...imgProps}
                className={cn(className, loaded ? "opacity-100" : "opacity-0")}
                onLoad={handleLoad}
                onError={handleError}
            />
        </div>
    );
}
